import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block border-r border-border bg-zinc-950 text-white relative overflow-hidden">
        <div className="absolute inset-0 grid-lines opacity-20 pointer-events-none" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <Link to="/" className="font-display font-black text-2xl tracking-tight">
            Rule<span className="text-primary">AI</span><span className="text-zinc-500">.systems</span>
          </Link>
          <div>
            <div className="overline text-accent mb-4">/ COMMAND CENTER</div>
            <h2 className="font-display text-4xl font-bold leading-tight">
              Standardize.<br/>Automate.<br/>Improve.
            </h2>
            <p className="text-zinc-400 mt-6 max-w-md">
              The AI-powered Business OS trusted by operations, marketing, HR, and quality teams.
            </p>
          </div>
          <div className="overline text-zinc-500">◉ SECURE ENTERPRISE ACCESS</div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="overline text-primary mb-2">/ SIGN IN</div>
          <h1 className="font-display text-3xl font-bold">Welcome back.</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Access your workspace.
          </p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email" type="email" required autoFocus
                data-testid="login-email"
                className="rounded-sm mt-1.5"
                value={email} onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <Label htmlFor="pw">Password</Label>
              <Input
                id="pw" type="password" required
                data-testid="login-password"
                className="rounded-sm mt-1.5"
                value={password} onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button
              type="submit" disabled={busy}
              data-testid="login-submit"
              className="w-full rounded-sm bg-primary hover:bg-primary/90 h-11"
            >
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-muted-foreground">
            No account?{" "}
            <Link to="/register" className="text-primary hover:underline" data-testid="link-register">
              Create one
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
